import { Prop, Vue } from "vue-property-decorator";

export class AppFormatTimeComponent extends Vue {
    @Prop({ required: true })
    value!: Date | number;

    @Prop({ default: "HH:MM" })
    format!: string;
}
